import React from "react";
import { Box, Button, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const RoundedButtons = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Rounded Buttons
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          title={"five variants of Rounded Button. adding 'rounded' props can change the basic button to rounded one."}
          language={"js"}
          value={
            '        <Button size={"small"} rounded>Contained</Button>\n' +
            '        <Button size={"small"} rounded variant={"outlined"}>outlined</Button>\n' +
            '        <Button size={"small"} rounded variant={"text"}>text</Button>\n' +
            '        <Button size={"small"} rounded variant={"tonal"} color={"primary"}>\n' +
            "          tonal\n" +
            "        </Button>\n" +
            '        <Button size={"small"} rounded variant={"noPadding"} color={"primary"}>\n' +
            "          noPadding\n" +
            "        </Button>"
          }
        >
          <Button size={"small"} sx={{ borderRadius: "50px" }}>
            Contained
          </Button>
          <Button
            size={"small"}
            variant={"outlined"}
            sx={{ borderRadius: "50px" }}
          >
            outlined
          </Button>
          <Button size={"small"} variant={"text"} sx={{ borderRadius: "50px" }}>
            text
          </Button>
          <Button
            size={"small"}
            variant={"tonal"}
            color={"primary"}
            sx={{ borderRadius: "50px" }}
          >
            tonal
          </Button>
          <Button
            size={"small"}
            variant={"noPadding"}
            color={"primary"}
            sx={{ borderRadius: "50px" }}
          >
            noPadding
          </Button>
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default RoundedButtons;
